const tierByQuantity = (quantity) => {
  if (quantity >= 3) return 3;

  if (quantity >= 1) return quantity;

  return 1;
};

export default tierByQuantity;
